import styled from 'styled-components';

const Content = styled.div`
  max-width: 1024px;
  margin: 2rem auto 1rem;
`;

export default { Content };
